import { UnknownAction, ThunkDispatch } from "@reduxjs/toolkit";
import { BattleFormationRefinedTroop } from "../../game-engine/types";

export interface ConfirmDialogType {
  id?: string | number | null;
  open: boolean;
  submit?: (() => void | Promise<void>) | null;
  title?: string;
  msg: string | React.ReactNode;
}

export interface MonthlyCompetition {
  startDate: string;
  endDate: string;
  rewardPool: number;
  increasePerSecond: number;
}

export type CompetitionType = {
  startDate: string;
  endDate: string;
  rewardPool: number;
  increasePerSecond: number;
};

export type RecentBattlePlayerType = {
  playerId: number;
  isWinner: boolean;
  isAttacker: boolean;
  username: string;
  photoFile?: string; // Optional since some players might not have a photoFile
};
export type RecentBattleTroopType = {
  playerTroopId: number;
  playerId: number;
  troopId: number;
  level: number;
  name: string;
  icon: string;
}

type Match = {
  id: number;
  endTime: string;
  startTime: string;
  adventureMode: number;
  result: number;
  energyCost: number;
  bloodGemReward: number;
  clegReward:number,
  formation?:string;
  defendFormation?:string;
  players: RecentBattlePlayerType[];
  isThereWinner?: boolean;
  attackerTroops?: BattleFormationRefinedTroop[];
  defenderTroops?: BattleFormationRefinedTroop[];
};


export type RecentMatchesData = {
  data: Match[];
  totalCount: number;
};



export type AppDispatch = ThunkDispatch<string, any, UnknownAction>;


export type EventBanner = {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
  iconUrl?: string;
  isActive: boolean;
  startDate: string;
  endDate: string;
  link: string;
  html?: string;
  popupId?: number;
};

export type StickyHeader = {
  id: number;
  title: string;
  description: string;
  text: string;
  link: string;
  backgroundColor: string;
  textColor: string;
  isActive: boolean;
};

/** What kind of release a game update describes; the server sends the number. */
export enum GameUpdateCategory {
  None = 0,
  NewFeature = 1,
  Improvement = 2,
  Balance = 3,
  Fixes = 4,
  Event = 5,
}

export type GameUpdate = {
  id: number;
  title: string;
  description: string;
  html: string;
  date: string;
  iconUrl: string;
  isActive: boolean;
  /** A version label such as "2.24". */
  version?: string;
  category?: GameUpdateCategory;
};

/** A page of GET /api/v2/announcement/getgameupdates: the shown updates, newest first. */
export type GameUpdatesPage = {
  result: GameUpdate[];
  count: number;
};

export type Popup = {
  id: number;
  title: string;
  description: string;
  startDate: string; // ISO date format
  endDate: string;   // ISO date format
  html: string;      // HTML content as string
  displayCount: number; // Number of times it should be displayed
  hasDontShowOption: boolean; // Whether user can opt out
  dontShowAgain: boolean; // If user has opted out
  isActive: boolean; // Determines visibility
  displayedCount?: number; // Number of times it has been displayed
};
export type PopupDisplay = {
  popupId: number;
  displayedCount: number;
  // Whose count this is; records from before it was kept have none.
  playerId?: number;
  // When the popup last opened by itself (ms since epoch).
  lastShownAt?: number;
  // The player ticked "Don't show again" (also saved on the server).
  dontShowAgain?: boolean;
};
export type GameAnnouncements = {
  eventBanners: EventBanner[];
  stickyHeaders: StickyHeader[];
  popups: Popup[]; // Assuming empty, adjust as needed
  gameUpdates: GameUpdate[];
  displays?:PopupDisplay[];
  // When this list arrived from the server (ms). The store keeps the last
  // session's list, which must not open popups before the fresh one arrives.
  fetchedAt?: number;
};


export type EventConfig = {
  startTime: string;      // ISO date format
  endTime: string;        // ISO date format
  iconUrl: string;        // URL to event icon
  title: string;          // Event title
  description: string;    // Event description
  isOpen: boolean;        // Whether event is currently active
};
